import Animate from './Animate';
import AnimateChild from './AnimateChild';
import CSSMotion from './CSSMotion';

export { AnimateChild, CSSMotion };

export default Animate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-animate@3.0.0-rc.6@rc-animate/es/index.js
// module id = 49
// module chunks = 0